import { render, staticRenderFns } from "./RelationListItem.vue?vue&type=template&id=db8b59d0&scoped=true"
import script from "./RelationListItem.vue?vue&type=script&lang=js"
export * from "./RelationListItem.vue?vue&type=script&lang=js"
import style0 from "./RelationListItem.vue?vue&type=style&index=0&id=db8b59d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8b59d0",
  null
  
)

export default component.exports